export default {
  global: (props) => ({
    '*': {
      // TODO: 升級到 React 18 and Chakra UI v2.0，並設定特定的 localStorage key 後，移除以下
      borderColor: props.theme.colors.gray[200],
      '::placeholder': {
        color: props.theme.colors.gray[400],
      },
    },
    body: {
      bgColor: '#f0f2f5',
      color: 'rgba(0, 0, 0, 1)',
    },
    button: {
      _hover: {
        cursor: 'pointer',
      },
    },
    input: {
      padding: '0px',
      borderLeft: 'none',
      borderTop: 'none',
      borderRight: 'none',
    },
  }),
};
